<unclaimed-message [task]="task" (claimed)="getTask()"></unclaimed-message>
@if (task?.purchaseRequisition) {
  <purchase-requisition-detail
    [purchaseRequisition]="task.purchaseRequisition"
    [editingWithDialog]="true"
    [task]="task"
    #purchaseRequisitionDetailComponent
    >
    <ng-container *removeIfUnclaimed="task">
      <div class="row justify-content-end mb-2">
        <div class="col-auto">
          <task-hint-display [hint]="task.hint"></task-hint-display>
        </div>
      </div>
      <div class="row justify-content-end mb-2">
        <div class="col-auto">
          <iim-advanced-autocomplete
            [formControl]="selectedApproverCtrl"
            [showLabel]="true"
            [label]="approverLabel | translate"
            [required]="task.approverRequired"
            >
            @for (approver of task.possibleApprovers; track approver) {
              <iim-autocomplete-option [value]="approver">
                {{ approver | person }}
              </iim-autocomplete-option>
            }
          </iim-advanced-autocomplete>
        </div>
      </div>
      <div class="row justify-content-end mb-2">
        <div class="col-auto">
          <button
            class="btn btn-primary"
            [disabled]="completionBlocked"
            (click)="complete()"
            >
            <em class="fas fa-arrow-right pe-1"></em>
            @if (task.approverRequired || selectedApproverCtrl.value) {
              <span>
                {{ 'weiter mit ausgewähltem Freigeber' | translate }}
              </span>
            }
            @if (!task.approverRequired && !selectedApproverCtrl.value) {
              <span>
                {{ 'weiter ohne optionalen Freigeber' | translate }}
              </span>
            }
          </button>
        </div>
      </div>
    </ng-container>
    <div class="row justify-content-end mb-2" *showIfUnclaimed="task">
      <claim-btn [task]="task" (claimed)="getTask()"></claim-btn>
    </div>
  </purchase-requisition-detail>
}
